import actions from './actions'

export default {
  actions,
  namespaced: true,
}

